import { render, staticRenderFns } from "./LayoutMail.vue?vue&type=template&id=5cb59ce4&"
import script from "./LayoutMail.vue?vue&type=script&lang=js&"
export * from "./LayoutMail.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports